/* ==========================================================================
   HUMANSOFGLORY — Global theme JS
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initMobileNav();
    initSearchToggle();
    initCartDrawer();
    initProductGallery();
    initVariantSelector();
    initQuantitySteppers();
    initQuickAdd();
    initCartLineUpdates();
    initHeaderScroll();
  }

  /* ----------------------------------------------------------------------
     Mobile nav
     ---------------------------------------------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var isOpen = nav.hasAttribute('data-nav-open');
      if (isOpen) {
        nav.removeAttribute('data-nav-open');
        nav.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        nav.removeAttribute('hidden');
        nav.setAttribute('data-nav-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ----------------------------------------------------------------------
     Header: hide on scroll down, reveal on scroll up
     ---------------------------------------------------------------------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var lastScrollY = window.scrollY;
    var ticking = false;
    var threshold = 8;
    var revealAt = header.offsetHeight;

    function onScroll() {
      var currentY = window.scrollY;
      var diff = currentY - lastScrollY;

      if (currentY <= revealAt) {
        header.classList.remove('site-header--hidden');
      } else if (diff > threshold) {
        header.classList.add('site-header--hidden');
      } else if (diff < -threshold) {
        header.classList.remove('site-header--hidden');
      }

      lastScrollY = currentY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ----------------------------------------------------------------------
     Search bar toggle
     ---------------------------------------------------------------------- */
  function initSearchToggle() {
    var toggle = document.querySelector('[data-search-toggle]');
    var bar = document.querySelector('[data-search-bar]');
    if (!toggle || !bar) return;

    toggle.addEventListener('click', function () {
      var isHidden = bar.hasAttribute('hidden');
      if (isHidden) {
        bar.removeAttribute('hidden');
        var input = bar.querySelector('input[type="search"]');
        if (input) input.focus();
      } else {
        bar.setAttribute('hidden', '');
      }
    });
  }

  /* ----------------------------------------------------------------------
     Cart drawer open / close
     ---------------------------------------------------------------------- */
  function initCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    var openBtn = document.querySelector('[data-cart-toggle]');
    if (!drawer) return;

    var overlay = document.createElement('div');
    overlay.className = 'cart-drawer-overlay';
    document.body.appendChild(overlay);

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (openBtn) {
      openBtn.addEventListener('click', openDrawer);
    }

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-cart-close]');
      if (closeBtn) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Expose for quick-add to call after adding to cart
    window.HOG = window.HOG || {};
    window.HOG.openCartDrawer = openDrawer;
    window.HOG.closeCartDrawer = closeDrawer;
  }

  /* ----------------------------------------------------------------------
     Product gallery: thumbnail click swaps active image
     ---------------------------------------------------------------------- */
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var images = gallery.querySelectorAll('[data-gallery-index]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-gallery-thumb');

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        images.forEach(function (img) {
          if (img.getAttribute('data-gallery-index') === index) {
            img.classList.add('is-active');
          } else {
            img.classList.remove('is-active');
          }
        });
      });
    });

    var prevBtn = gallery.querySelector('[data-thumb-prev]');
    var nextBtn = gallery.querySelector('[data-thumb-next]');
    var track = gallery.querySelector('[data-product-gallery] .product-page__thumb-track') || gallery.querySelector('.product-page__thumb-track');

    if (prevBtn && track) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -180, behavior: 'smooth' });
      });
    }
    if (nextBtn && track) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: 180, behavior: 'smooth' });
      });
    }
  }

  /* ----------------------------------------------------------------------
     Variant option buttons <-> hidden select sync
     ---------------------------------------------------------------------- */
  function initVariantSelector() {
    var forms = document.querySelectorAll('[data-product-form]');

    forms.forEach(function (form) {
      var select = form.querySelector('[data-variant-select]');
      if (!select) return;

      var optionGroups = form.querySelectorAll('[data-option-index]');
      if (!optionGroups.length) return;

      // Initialize first available option as selected for each group visually
      optionGroups.forEach(function (group) {
        var buttons = group.querySelectorAll('[data-option-value]');
        if (buttons.length) buttons[0].classList.add('is-selected');

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            buttons.forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            syncVariant(form, select);
          });
        });
      });
    });
  }

  function syncVariant(form, select) {
    var optionGroups = form.querySelectorAll('[data-option-index]');
    var selectedValues = [];

    optionGroups.forEach(function (group) {
      var selectedBtn = group.querySelector('.is-selected');
      if (selectedBtn) {
        selectedValues.push(selectedBtn.getAttribute('data-option-value'));
      }
    });

    var options = Array.prototype.slice.call(select.options);
    var match = options.find(function (opt) {
      return opt.textContent.trim().split(' - ')[0].trim() === selectedValues.join(' / ');
    });

    // Fallback: try matching by checking each option's title text contains all selected values
    if (!match) {
      match = options.find(function (opt) {
        return selectedValues.every(function (val) {
          return opt.textContent.indexOf(val) !== -1;
        });
      });
    }

    if (match) {
      select.value = match.value;
      var submitBtn = form.querySelector('.product-form__submit');
      if (submitBtn) {
        if (match.disabled) {
          submitBtn.setAttribute('disabled', '');
          submitBtn.textContent = 'SOLD OUT';
        } else {
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = 'ADD TO CART';
        }
      }
    }
  }

  /* ----------------------------------------------------------------------
     Quantity steppers (product page + cart)
     ---------------------------------------------------------------------- */
  function initQuantitySteppers() {
    document.addEventListener('click', function (e) {
      var decreaseBtn = e.target.closest('[data-qty-decrease]');
      var increaseBtn = e.target.closest('[data-qty-increase]');

      if (decreaseBtn) {
        var input1 = decreaseBtn.parentElement.querySelector('input[type="number"]');
        if (input1) {
          var val1 = parseInt(input1.value, 10) || 1;
          input1.value = Math.max(1, val1 - 1);
          input1.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (increaseBtn) {
        var input2 = increaseBtn.parentElement.querySelector('input[type="number"]');
        if (input2) {
          var val2 = parseInt(input2.value, 10) || 1;
          input2.value = val2 + 1;
          input2.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  /* ----------------------------------------------------------------------
     Quick add: AJAX add-to-cart from product grid cards
     ---------------------------------------------------------------------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled) return;

      e.preventDefault();

      var productUrl = btn.getAttribute('data-product-url');
      if (!productUrl) return;

      // Fetch the product page JSON to get the first available variant id
      fetch(productUrl + '.js')
        .then(function (res) { return res.json(); })
        .then(function (product) {
          var variant = product.variants.find(function (v) { return v.available; });
          if (!variant) {
            btn.textContent = 'SOLD OUT';
            return;
          }
          return addToCart(variant.id, 1);
        })
        .then(function (result) {
          if (result) {
            refreshCartDrawer();
            if (window.HOG && window.HOG.openCartDrawer) {
              window.HOG.openCartDrawer();
            }
          }
        })
        .catch(function (err) {
          console.error('Quick add failed:', err);
        });
    });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('[data-cart-count]');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.setAttribute('data-cart-count', cart.item_count);
        }
        // Reload drawer markup section via Section Rendering API would be ideal;
        // simplest robust fallback is a full drawer section fetch.
        fetch(window.location.pathname + '?sections=cart-drawer')
          .catch(function () { /* section not configured; fallback handled by page reload on cart page */ });
      });
  }

  /* ----------------------------------------------------------------------
     Cart line item quantity updates (cart page) — debounced auto-submit
     ---------------------------------------------------------------------- */
  function initCartLineUpdates() {
    var cartForm = document.querySelector('.cart-form');
    if (!cartForm) return;

    var debounceTimers = {};

    cartForm.addEventListener('input', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;

      var key = input.getAttribute('data-cart-qty');
      clearTimeout(debounceTimers[key]);
      debounceTimers[key] = setTimeout(function () {
        cartForm.submit();
      }, 600);
    });

    cartForm.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (!removeBtn) return;

      e.preventDefault();
      var key = removeBtn.getAttribute('data-cart-remove');
      var row = removeBtn.closest('.cart-table__row');
      var qtyInput = row ? row.querySelector('[data-cart-qty]') : null;
      if (qtyInput) {
        qtyInput.value = 0;
      }
      cartForm.submit();
    });
  }

})();
